import dayjs from 'dayjs';

export default (date: Date | string): number => dayjs(date).date();
